const ControlPanelMixin = {
  methods: {
    closePanel() {
      this.$emit('closePanel', {
        name: this.name,
      });
    },
  },
};

export default ControlPanelMixin;
